export default __webpack_public_path__ + "static/media/provider_13.98dc48c1.png";